export enum InvoiceType {
    Monthly = 1,
    Other = 2,
}

export const InvoiceTypes = [
    { Id: InvoiceType.Monthly, TextId: 'Monthly invoice' },
    { Id: InvoiceType.Other, TextId: 'Other invoice' },
];

export enum InvoiceStatusType {
    Generated = 0,
    Printed = 1,
    Sent = 2,
    Paid = 3,
}
